<div class="terms animate__animated animate__fadeIn">
  <h1>
    Terms and Conditions
  </h1>

  <h2>
    General Information
  </h2>
  <p>
    The objective of CoinCatapult.com website (hereinafter referred to as the "Website") is to provide publishing services (priority positioning, advertisements, editorials, banners, and others) for the users. Any person visiting the Website is considered a User. The current terms and conditions apply to all users. The terms and conditions from this page are applied to every page of the Website. Failure to comply with the Terms and Conditions may result in suspension of User access to the Website, without prior notice.
  </p>

  <h2>
    Introduction
  </h2>

  <p>
    The Website is an advertising platform that helps the advertisers to promote their projects.
    We do not endorse any project listed on the Website, and we encourage each User to <b>Do Your Own Research (DYOR)</b>.
  </p>

  <h2>
    Listing on CoinCatapult
  </h2>
  <p>
    Any project can submit their coin using the submission form on our website. We do not endorse or check the validity of this information.
  </p>
  <p>
    Listings with more than 100 votes will appear in "All Time" and "Today". Otherwise they are listed in "New Listings".
  </p>
  <p>
    CoinCatapult has the right to remove any project for any given reason, or remove any votes if CoinCatapult thinks these were illegitimate.
  </p>
  <p>
    If you see any incorrect information on CoinCatapult, please contact us at <a rel="nofollow noopener" href="mailto: contact@coincatapult.com">contact@coincatapult.com</a> and we will check and fix the errors.
  </p>

  <h2>
    User Generated Content (UGC)
  </h2>
  <p>
    UGC means any material including, but not limited to, text, images, videos and any other media that Users upload to our Website.
  </p>
  <p>
    The User is fully responsible for it's content. We decline any responsibility for the UGC.
  </p>
  <p>
    The User grants us full rights for the uploaded content.
  </p>
  <p>
    The UGC must be in compliance with the current Terms and Conditions.
  </p>
  <p>
    The UGC must comply with local laws and must not infringe any third party copyright.
  </p>
  <p>
    We do not accept watermarks or overlays on the images. Such images will be deleted without notification.
  </p>
  <p>
    We reserve the right to edit or delete any UGC uploaded to our Website.
  </p>

  <h2>
    Restrictions
  </h2>
  <p>
    You are specifically restricted from all of the following:
  </p>

  <ul>
    <li>automating visits, votes, or any other action on this Website</li>
    <li>publishing any Website material in any other media;</li>
    <li>selling, sublicensing and/or otherwise commercializing any Website material;</li>
    <li>publicly performing and/or showing any Website material;</li>
    <li>using this Website in any way that is or may be damaging to this Website;</li>
    <li>using this Website in any way that impacts user access to this Website;</li>
    <li>using this Website contrary to applicable laws and regulations, or in any way may cause harm to the Website, or to any person or business entity;</li>
    <li>engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website;</li>
    <li>using this Website to engage in any advertising or marketing.</li>
  </ul>

  <h2>
    Privacy Policy
  </h2>
  <p>
    We <3 Privacy!
  </p>
  <p>
    We will never trade, sell or share your data with anyone.
  </p>
  <p>
    We collect the minimum amount of data required to safely operate our Website.
  </p>
  <p>
    In terms of security, our Website is hosted in a secured environment, and it uses strict end-to-end encryption. This means your data is encrypted before being sent over the web.
  </p>
  <p>
    By using our Website, you consent to the collection and use of this information by CoinCatapult.com. Any changes made in the future will be posted on the Privacy Policy section of the Terms and Conditions.
  </p>

  <h2>
    No warranties
  </h2>
  <p>
    This Website is provided "as is", and CoinCatapult expresses no representations or warranties, of any kind related to this Website or the materials contained on this Website. Also, nothing contained on this Website shall be interpreted as advising you.
  </p>

  <h2>
    Limitation of liability
  </h2>
  <p>
    In no event shall CoinCatapult, nor any of its officers, directors and employees, shall be held liable for anything arising out of or in any way connected with your use of this Website whether such liability is under contract. CoinCatapult, including its officers, directors and employees shall not be held liable for any indirect, consequential or special liability arising out of or in any way related to your use of this Website.
  </p>

  <h2>
    Indemnification
  </h2>
  <p>
    You hereby indemnify to the fullest extent CoinCatapult from and against any and/or all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms.
  </p>

  <h2>
    Severability
  </h2>
  <p>
    If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be deleted without affecting the remaining provisions herein.
  </p>

  <h2>
    Changes To This Agreement
  </h2>
  <p>
    We reserve the right to modify the Terms and Conditions at any time and without prior notice. By continuing to use the Website after any changes constitutes your acceptance of the new Terms and Conditions.
  </p>
  <p>
    By using this Website you are expected to review these Terms on a regular basis.
  </p>

  <h2>
    Entire Agreement
  </h2>
  <p>
    These Terms constitute the entire agreement between CoinCatapult and you in relation to your use of this Website, and supersede all prior agreements and understandings.
  </p>

  <h2>
    Governing Law & Jurisdiction
  </h2>
  <p>
    These Terms will be governed by and interpreted in accordance with the laws of the State of us, and you submit to the non-exclusive jurisdiction of the state and federal courts located in us for the resolution of any disputes.
  </p>
</div>
